module.exports = __webpack_public_path__ + "static/media/hero_image.6c09c5b6.png";